module.exports = __webpack_public_path__ + "img/EuclidEnercity-BoldItalic-WebS.997cbc51.svg";